<template>
  <li
    class="notice_card"
    :class="['title', 'border-top-1px', 'border-bottom-1px', isread ? 'read_notice' : '']"
    @click="changeStatus"
  >
    <div :class="['notice_main']">
      <p
        :class="['date']"
        v-text="date"
      />
      <h2
        :class="['title']"
        v-text="title"
      />
      <p
        :class="['content']"
        v-html="$xss(content, $xssOptions)"
      />
    </div>
  </li>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    id: {
      type: Number,
      default: 0
    },
    date: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    },
    isread: {
      type: Boolean,
      default: false
    },
    inquiryid: {
      type: Number,
      default: 0
    },
    attribute: {
      type: [Object, Array],
      default: () => ({})
    }
  },
  methods: {
    changeStatus () {
      // console.log(this.isread)
      this.$emit('change', { isread: this.isread, index: this.index, id: this.id, title: this.title, inquiryid: this.inquiryid, attribute: this.attribute })
    }
  }
}
</script>

<style scoped lang="scss">
.notice_card {
  width: 100%;
  margin-top: 8px;
  overflow: hidden;
  background: #fff;
  // border-top: 1px solid #dbdbdb;
  // border-bottom: 1px solid #dbdbdb;
  box-sizing: border-box;
  &.read_notice .notice_main {
    .title,
    .date,
    .content {
      font-weight: normal;
      color: #888;
    }
  }
  .notice_main {
    font-size: 14px;
    margin: 24px;
    .title,
    .date {
      color: #333;
      font-weight: bold;
    }
    .title {
      margin: 12px 0;
      font-weight: bold;
    }
    .content {
      line-height: 21px;
      color: #333;
      font-weight: bold;
    }
  }
}
</style>
